

















































import { Component } from 'vue-property-decorator';
import SettingMixin from '@/components/ViewComponent/Setting/setting.mixin';

@Component<Language>({})
export default class Language extends SettingMixin {}
